import { toast } from "react-toastify";
import Parse from "../../api/ApiConfig";

export const updateUserDetails = async (formData) => {
	try {
		const currentUser = Parse.User.current();
		currentUser.set("lastName", formData.lastName);
		currentUser.set("firstName", formData.firstName);
		currentUser.set("email", formData.email);
		currentUser.set("phone", formData.phone);
		currentUser.set("gender", formData.gender);
		currentUser.set("homeAddress", formData.homeAddress);
		currentUser.set("privileges", formData.privileges);

		const response = await currentUser.save();
		return response;
	} catch (error) {
		console.log(error);
		return null;
	}
};

export const updateUserPassword = async (formData) => {
	try {
		console.log(formData);

		const response = await fetch(`${Parse.serverURL}/functions/updatePassword`, {
			method: "POST",
			headers: {
				"X-Parse-Application-Id": process.env.REACT_APP_APP_ID,
				"X-Parse-Session-Token": Parse.User.current().getSessionToken(),
			},
			body: JSON.stringify(formData),
			// body: JSON.stringify({ email, password }),
		});

		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		console.log(error);
		return null;
	}
};

export const BUSINESSTYPE = [
	"Restaurant",
	"Retail Store",
	"Technology",
	"Consulting Firm",
	"Construction",
	"Healthcare",
	"Transportation Service",
	"Financial Institutions",
	"Media and Entertainment",
	"Agriculture",
	"Automotive Industry",
	"Fashion Retailer",
	"Education Institution",
	"E-commerce Business",
	"Manufacturing Company",
	"Others",
];

export const stateAndLga = [
	{
		state: "Adamawa",
		alias: "adamawa",
		lgas: [
			"Demsa",
			"Fufure",
			"Ganye",
			"Gayuk",
			"Gombi",
			"Grie",
			"Hong",
			"Jada",
			"Larmurde",
			"Madagali",
			"Maiha",
			"Mayo Belwa",
			"Michika",
			"Mubi North",
			"Mubi South",
			"Numan",
			"Shelleng",
			"Song",
			"Toungo",
			"Yola North",
			"Yola South",
		],
		postalCode: "640001",
	},
	{
		state: "Akwa Ibom",
		alias: "akwa_ibom",
		lgas: [
			"Abak",
			"Eastern Obolo",
			"Eket",
			"Esit Eket",
			"Essien Udim",
			"Etim Ekpo",
			"Etinan",
			"Ibeno",
			"Ibesikpo Asutan",
			"Ibiono-Ibom",
			"Ikot Abasi",
			"Ika",
			"Ikono",
			"Ikot Ekpene",
			"Ini",
			"Mkpat-Enin",
			"Itu",
			"Mbo",
			"Nsit-Atai",
			"Nsit-Ibom",
			"Nsit-Ubium",
			"Obot Akara",
			"Okobo",
			"Onna",
			"Oron",
			"Udung-Uko",
			"Ukanafun",
			"Oruk Anam",
			"Uruan",
			"Urue-Offong/Oruko",
			"Uyo",
		],
		postalCode: "520001",
	},
	{
		state: "Anambra",
		alias: "anambra",
		lgas: [
			"Aguata",
			"Anambra East",
			"Anaocha",
			"Awka North",
			"Anambra West",
			"Awka South",
			"Ayamelum",
			"Dunukofia",
			"Ekwusigo",
			"Idemili North",
			"Idemili South",
			"Ihiala",
			"Njikoka",
			"Nnewi North",
			"Nnewi South",
			"Ogbaru",
			"Onitsha North",
			"Onitsha South",
			"Orumba North",
			"Orumba South",
			"Oyi",
		],
		postalCode: "420001",
	},
	{
		state: "Ogun",
		alias: "ogun",
		lgas: [
			"Abeokuta North",
			"Abeokuta South",
			"Ado-Odo/Ota",
			"Egbado North",
			"Ewekoro",
			"Egbado South",
			"Ijebu North",
			"Ijebu East",
			"Ifo",
			"Ijebu Ode",
			"Ijebu North East",
			"Imeko Afon",
			"Ikenne",
			"Ipokia",
			"Odeda",
			"Obafemi Owode",
			"Odogbolu",
			"Remo North",
			"Ogun Waterside",
			"Shagamu",
		],
		postalCode: "110001",
	},
	{
		state: "Ondo",
		alias: "ondo",
		lgas: [
			"Akoko North-East",
			"Akoko North-West",
			"Akoko South-West",
			"Akoko South-East",
			"Akure North",
			"Akure South",
			"Ese Odo",
			"Idanre",
			"Ifedore",
			"Ilaje",
			"Irele",
			"Ile Oluji/Okeigbo",
			"Odigbo",
			"Okitipupa",
			"Ondo West",
			"Ose",
			"Ondo East",
			"Owo",
		],
		postalCode: "340001",
	},
	{
		state: "Rivers",
		alias: "rivers",
		lgas: [
			"Abua/Odual",
			"Ahoada East",
			"Ahoada West",
			"Andoni",
			"Akuku-Toru",
			"Asari-Toru",
			"Bonny",
			"Degema",
			"Emuoha",
			"Eleme",
			"Ikwerre",
			"Etche",
			"Gokana",
			"Khana",
			"Obio/Akpor",
			"Ogba/Egbema/Ndoni",
			"Ogu/Bolo",
			"Okrika",
			"Omuma",
			"Opobo/Nkoro",
			"Oyigbo",
			"Port Harcourt",
			"Tai",
		],
		postalCode: "500001",
	},
	{
		state: "Bauchi",
		alias: "bauchi",
		lgas: [
			"Alkaleri",
			"Bauchi",
			"Bogoro",
			"Damban",
			"Darazo",
			"Dass",
			"Gamawa",
			"Ganjuwa",
			"Giade",
			"Itas/Gadau",
			"Jama'are",
			"Katagum",
			"Kirfi",
			"Misau",
			"Ningi",
			"Shira",
			"Tafawa Balewa",
			"Toro",
			"Warji",
			"Zaki",
		],
		postalCode: "740001",
	},
	{
		state: "Benue",
		alias: "benue",
		lgas: [
			"Agatu",
			"Apa",
			"Ado",
			"Buruku",
			"Gboko",
			"Guma",
			"Gwer East",
			"Gwer West",
			"Katsina-Ala",
			"Konshisha",
			"Kwande",
			"Logo",
			"Makurdi",
			"Obi",
			"Ogbadibo",
			"Ohimini",
			"Oju",
			"Okpokwu",
			"Oturkpo",
			"Tarka",
			"Ukum",
			"Ushongo",
			"Vandeikya",
		],
		postalCode: "970001",
	},
	{
		state: "Borno",
		alias: "borno",
		lgas: [
			"Abadam",
			"Askira/Uba",
			"Bama",
			"Bayo",
			"Biu",
			"Chibok",
			"Damboa",
			"Dikwa",
			"Guzamala",
			"Gubio",
			"Hawul",
			"Gwoza",
			"Jere",
			"Kaga",
			"Kala/Balge",
			"Konduga",
			"Kukawa",
			"Kwaya Kusar",
			"Mafa",
			"Magumeri",
			"Maiduguri",
			"Mobbar",
			"Marte",
			"Monguno",
			"Ngala",
			"Nganzai",
			"Shani",
		],
		postalCode: "600001",
	},
	{
		state: "Bayelsa",
		alias: "bayelsa",
		lgas: ["Brass", "Ekeremor", "Kolokuma/Opokuma", "Nembe", "Ogbia", "Sagbama", "Southern Ijaw", "Yenagoa"],
		postalCode: "561001",
	},
	{
		state: "Cross River",
		alias: "cross_river",
		lgas: [
			"Abi",
			"Akamkpa",
			"Akpabuyo",
			"Bakassi",
			"Bekwarra",
			"Biase",
			"Boki",
			"Calabar Municipal",
			"Calabar South",
			"Etung",
			"Ikom",
			"Obanliku",
			"Obubra",
			"Obudu",
			"Odukpani",
			"Ogoja",
			"Yakuur",
			"Yala",
		],
		postalCode: "540001",
	},
	{
		state: "Delta",
		alias: "delta",
		lgas: [
			"Aniocha North",
			"Aniocha South",
			"Bomadi",
			"Burutu",
			"Ethiope West",
			"Ethiope East",
			"Ika North East",
			"Ika South",
			"Isoko North",
			"Isoko South",
			"Ndokwa East",
			"Ndokwa West",
			"Okpe",
			"Oshimili North",
			"Oshimili South",
			"Patani",
			"Sapele",
			"Udu",
			"Ughelli North",
			"Ukwuani",
			"Ughelli South",
			"Uvwie",
			"Warri North",
			"Warri South",
			"Warri South West",
		],
		postalCode: "320001",
	},
	{
		state: "Ebonyi",
		alias: "ebonyi",
		lgas: [
			"Abakaliki",
			"Afikpo North",
			"Ebonyi",
			"Afikpo South",
			"Ezza North",
			"Ikwo",
			"Ezza South",
			"Ivo",
			"Ishielu",
			"Izzi",
			"Ohaozara",
			"Ohaukwu",
			"Onicha",
		],
		postalCode: "840001",
	},
	{
		state: "Edo",
		alias: "edo",
		lgas: [
			"Akoko-Edo",
			"Egor",
			"Esan Central",
			"Esan North-East",
			"Esan South-East",
			"Esan West",
			"Etsako Central",
			"Etsako East",
			"Etsako West",
			"Igueben",
			"Ikpoba Okha",
			"Orhionmwon",
			"Oredo",
			"Ovia North-East",
			"Ovia South-West",
			"Owan East",
			"Owan West",
			"Uhunmwonde",
		],
		postalCode: "300001",
	},
	{
		state: "Ekiti",
		alias: "ekiti",
		lgas: [
			"Ado Ekiti",
			"Efon",
			"Ekiti East",
			"Ekiti South-West",
			"Ekiti West",
			"Emure",
			"Gbonyin",
			"Ido Osi",
			"Ijero",
			"Ikere",
			"Ilejemeje",
			"Irepodun/Ifelodun",
			"Ikole",
			"Ise/Orun",
			"Moba",
			"Oye",
		],
		postalCode: "360001",
	},
	{
		state: "Enugu",
		alias: "enugu",
		lgas: [
			"Awgu",
			"Aninri",
			"Enugu East",
			"Enugu North",
			"Ezeagu",
			"Enugu South",
			"Igbo Etiti",
			"Igbo Eze North",
			"Igbo Eze South",
			"Isi Uzo",
			"Nkanu East",
			"Nkanu West",
			"Nsukka",
			"Udenu",
			"Oji River",
			"Uzo Uwani",
			"Udi",
		],
		postalCode: "400001",
	},
	{
		state: "Federal Capital Territory",
		alias: "abuja",
		lgas: ["Abaji", "Bwari", "Gwagwalada", "Kuje", "Kwali", "Municipal Area Council"],
		postalCode: "900001",
	},
	{
		state: "Gombe",
		alias: "gombe",
		lgas: [
			"Akko",
			"Balanga",
			"Billiri",
			"Dukku",
			"Funakaye",
			"Gombe",
			"Kaltungo",
			"Kwami",
			"Nafada",
			"Shongom",
			"Yamaltu/Deba",
		],
		postalCode: "760001",
	},
	{
		state: "Jigawa",
		alias: "jigawa",
		lgas: [
			"Auyo",
			"Babura",
			"Buji",
			"Biriniwa",
			"Birnin Kudu",
			"Dutse",
			"Gagarawa",
			"Garki",
			"Gumel",
			"Guri",
			"Gwaram",
			"Gwiwa",
			"Hadejia",
			"Jahun",
			"Kafin Hausa",
			"Kazaure",
			"Kiri Kasama",
			"Kiyawa",
			"Kaugama",
			"Maigatari",
			"Malam Madori",
			"Miga",
			"Sule Tankarkar",
			"Roni",
			"Ringim",
			"Yankwashi",
			"Taura",
		],
		postalCode: "720001",
	},
	{
		state: "Oyo",
		alias: "oyo",
		lgas: [
			"Afijio",
			"Akinyele",
			"Atiba",
			"Atisbo",
			"Egbeda",
			"Ibadan North",
			"Ibadan North-East",
			"Ibadan North-West",
			"Ibadan South-East",
			"Ibarapa Central",
			"Ibadan South-West",
			"Ibarapa East",
			"Ido",
			"Ibarapa North",
			"Irepo",
			"Iseyin",
			"Itesiwaju",
			"Iwajowa",
			"Kajola",
			"Lagelu",
			"Ogbomosho North",
			"Ogbomosho South",
			"Ogo Oluwa",
			"Olorunsogo",
			"Oluyole",
			"Ona Ara",
			"Orelope",
			"Ori Ire",
			"Oyo",
			"Oyo East",
			"Saki East",
			"Saki West",
			"Surulere Oyo State",
		],
		postalCode: "200001",
	},
	{
		state: "Imo",
		alias: "imo",
		lgas: [
			"Aboh Mbaise",
			"Ahiazu Mbaise",
			"Ehime Mbano",
			"Ezinihitte",
			"Ideato North",
			"Ideato South",
			"Ihitte/Uboma",
			"Ikeduru",
			"Isiala Mbano",
			"Mbaitoli",
			"Isu",
			"Ngor Okpala",
			"Njaba",
			"Nkwerre",
			"Nwangele",
			"Obowo",
			"Oguta",
			"Ohaji/Egbema",
			"Okigwe",
			"Orlu",
			"Orsu",
			"Oru East",
			"Oru West",
			"Owerri Municipal",
			"Owerri North",
			"Unuimo",
			"Owerri West",
		],
		postalCode: "460001",
	},
	{
		state: "Kaduna",
		alias: "kaduna",
		postalCode: "700001",
		lgas: [
			"Birnin Gwari",
			"Chikun",
			"Giwa",
			"Ikara",
			"Igabi",
			"Jaba",
			"Jema'a",
			"Kachia",
			"Kaduna North",
			"Kaduna South",
			"Kagarko",
			"Kajuru",
			"Kaura",
			"Kauru",
			"Kubau",
			"Kudan",
			"Lere",
			"Makarfi",
			"Sabon Gari",
			"Sanga",
			"Soba",
			"Zangon Kataf",
			"Zaria",
		],
	},
	{
		state: "Kebbi",
		alias: "kebbi",
		postalCode: "860001",
		lgas: [
			"Aleiro",
			"Argungu",
			"Arewa Dandi",
			"Augie",
			"Bagudo",
			"Birnin Kebbi",
			"Bunza",
			"Dandi",
			"Fakai",
			"Gwandu",
			"Jega",
			"Kalgo",
			"Koko/Besse",
			"Maiyama",
			"Ngaski",
			"Shanga",
			"Suru",
			"Sakaba",
			"Wasagu/Danko",
			"Yauri",
			"Zuru",
		],
	},
	{
		state: "Kano",
		alias: "kano",
		postalCode: "800001",
		lgas: [
			"Ajingi",
			"Albasu",
			"Bagwai",
			"Bebeji",
			"Bichi",
			"Bunkure",
			"Dala",
			"Dambatta",
			"Dawakin Kudu",
			"Dawakin Tofa",
			"Doguwa",
			"Fagge",
			"Gabasawa",
			"Garko",
			"Garun Mallam",
			"Gezawa",
			"Gaya",
			"Gwale",
			"Gwarzo",
			"Kabo",
			"Kano Municipal",
			"Karaye",
			"Kibiya",
			"Kiru",
			"Kumbotso",
			"Kunchi",
			"Kura",
			"Madobi",
			"Makoda",
			"Minjibir",
			"Nasarawa",
			"Rano",
			"Rimin Gado",
			"Rogo",
			"Shanono",
			"Takai",
			"Sumaila",
			"Tarauni",
			"Tofa",
			"Tsanyawa",
			"Tudun Wada",
			"Ungogo",
			"Warawa",
			"Wudil",
		],
	},
	{
		state: "Kogi",
		alias: "kogi",
		postalCode: "260001",
		lgas: [
			"Ajaokuta",
			"Adavi",
			"Ankpa",
			"Bassa",
			"Dekina",
			"Ibaji",
			"Idah",
			"Igalamela Odolu",
			"Ijumu",
			"Kogi",
			"Kabba/Bunu",
			"Lokoja",
			"Ofu",
			"Mopa Muro",
			"Ogori/Magongo",
			"Okehi",
			"Okene",
			"Olamaboro",
			"Omala",
			"Yagba East",
			"Yagba West",
		],
	},
	{
		state: "Osun",
		alias: "osun",
		postalCode: "230001",
		lgas: [
			"Aiyedire",
			"Atakunmosa West",
			"Atakunmosa East",
			"Aiyedaade",
			"Boluwaduro",
			"Boripe",
			"Ife East",
			"Ede South",
			"Ife North",
			"Ede North",
			"Ife South",
			"Ejigbo",
			"Ife Central",
			"Ifedayo",
			"Egbedore",
			"Ila",
			"Ifelodun",
			"Ilesa East",
			"Ilesa West",
			"Irepodun",
			"Irewole",
			"Isokan",
			"Iwo",
			"Obokun",
			"Odo Otin",
			"Ola Oluwa",
			"Olorunda",
			"Oriade",
			"Orolu",
			"Osogbo",
		],
	},
	{
		state: "Sokoto",
		alias: "sokoto",
		postalCode: "840001",
		lgas: [
			"Gudu",
			"Gwadabawa",
			"Illela",
			"Isa",
			"Kebbe",
			"Kware",
			"Rabah",
			"Sabon Birni",
			"Shagari",
			"Silame",
			"Sokoto North",
			"Sokoto South",
			"Tambuwal",
			"Tangaza",
			"Tureta",
			"Wamako",
			"Wurno",
			"Yabo",
			"Binji",
			"Bodinga",
			"Dange Shuni",
			"Goronyo",
			"Gada",
		],
	},
	{
		state: "Plateau",
		alias: "plateau",
		postalCode: "930001",
		lgas: [
			"Bokkos",
			"Barkin Ladi",
			"Bassa",
			"Jos East",
			"Jos North",
			"Jos South",
			"Kanam",
			"Kanke",
			"Langtang South",
			"Langtang North",
			"Mangu",
			"Mikang",
			"Pankshin",
			"Qua'an Pan",
			"Riyom",
			"Shendam",
			"Wase",
		],
	},
	{
		state: "Taraba",
		alias: "taraba",
		postalCode: "660001",
		lgas: [
			"Ardo Kola",
			"Bali",
			"Donga",
			"Gashaka",
			"Gassol",
			"Ibi",
			"Jalingo",
			"Karim Lamido",
			"Kumi",
			"Lau",
			"Sardauna",
			"Takum",
			"Ussa",
			"Wukari",
			"Yorro",
			"Zing",
		],
	},
	{
		state: "Yobe",
		alias: "yobe",
		postalCode: "320001",
		lgas: [
			"Bade",
			"Bursari",
			"Damaturu",
			"Fika",
			"Fune",
			"Geidam",
			"Gujba",
			"Gulani",
			"Jakusko",
			"Karasuwa",
			"Machina",
			"Nangere",
			"Nguru",
			"Potiskum",
			"Tarmuwa",
			"Yunusari",
			"Yusufari",
		],
	},
	{
		state: "Zamfara",
		alias: "zamfara",
		postalCode: "860001",
		lgas: [
			"Anka",
			"Birnin Magaji/Kiyaw",
			"Bakura",
			"Bukkuyum",
			"Bungudu",
			"Gummi",
			"Gusau",
			"Kaura Namoda",
			"Maradun",
			"Shinkafi",
			"Maru",
			"Talata Mafara",
			"Tsafe",
			"Zurmi",
		],
	},
	{
		state: "Lagos",
		alias: "lagos",
		postalCode: "100001",
		lgas: [
			"Agege",
			"Ajeromi-Ifelodun",
			"Alimosho",
			"Amuwo-Odofin",
			"Badagry",
			"Apapa",
			"Epe",
			"Eti Osa",
			"Ibeju-Lekki",
			"Ifako-Ijaiye",
			"Ikeja",
			"Ikorodu",
			"Kosofe",
			"Lagos Island",
			"Mushin",
			"Lagos Mainland",
			"Ojo",
			"Oshodi-Isolo",
			"Shomolu",
			"Surulere",
		],
	},
	{
		state: "Katsina",
		alias: "katsina",
		postalCode: "820001",
		lgas: [
			"Bakori",
			"Batagarawa",
			"Batsari",
			"Baure",
			"Bindawa",
			"Charanchi",
			"Danja",
			"Dandume",
			"Dan Musa",
			"Daura",
			"Dutsi",
			"Dutsin Ma",
			"Faskari",
			"Funtua",
			"Ingawa",
			"Jibia",
			"Kafur",
			"Kaita",
			"Kankara",
			"Kankia",
			"Katsina",
			"Kurfi",
			"Kusada",
			"Mai'Adua",
			"Malumfashi",
			"Mani",
			"Mashi",
			"Matazu",
			"Musawa",
			"Rimi",
			"Sabuwa",
			"Safana",
			"Sandamu",
			"Zango",
		],
	},
	{
		state: "Kwara",
		alias: "kwara",
		postalCode: "240001",
		lgas: [
			"Asa",
			"Baruten",
			"Edu",
			"Ilorin East",
			"Ifelodun",
			"Ilorin South",
			"Ekiti Kwara State",
			"Ilorin West",
			"Irepodun",
			"Isin",
			"Kaiama",
			"Moro",
			"Offa",
			"Oke Ero",
			"Oyun",
			"Pategi",
		],
	},
	{
		state: "Nasarawa",
		alias: "nasarawa",
		postalCode: "962001",
		lgas: [
			"Akwanga",
			"Awe",
			"Doma",
			"Karu",
			"Keana",
			"Keffi",
			"Lafia",
			"Kokona",
			"Nasarawa Egon",
			"Nasarawa",
			"Obi",
			"Toto",
			"Wamba",
		],
	},
	{
		state: "Niger",
		alias: "niger",
		postalCode: "920001",
		lgas: [
			"Agaie",
			"Agwara",
			"Bida",
			"Borgu",
			"Bosso",
			"Chanchaga",
			"Edati",
			"Gbako",
			"Gurara",
			"Katcha",
			"Kontagora",
			"Lapai",
			"Lavun",
			"Mariga",
			"Magama",
			"Mokwa",
			"Mashegu",
			"Moya",
			"Paikoro",
			"Rafi",
			"Rijau",
			"Shiroro",
			"Suleja",
			"Tafa",
			"Wushishi",
		],
	},
	{
		state: "Abia",
		alias: "abia",
		postalCode: "440001",
		lgas: [
			"Aba North",
			"Arochukwu",
			"Aba South",
			"Bende",
			"Isiala Ngwa North",
			"Ikwuano",
			"Isiala Ngwa South",
			"Isuikwuato",
			"Obi Ngwa",
			"Ohafia",
			"Osisioma",
			"Ugwunagbo",
			"Ukwa East",
			"Ukwa West",
			"Umuahia North",
			"Umuahia South",
			"Umu Nneochi",
		],
	},
];

export const createOrUpdateCompanyDetails = async (dataToUpdate, objectId) => {
	const query = new Parse.Query("CommonDetails");

	if (objectId) {
		query.equalTo("objectId", objectId);
	}

	try {
		let myObject = null;
		try {
			myObject = await query.first();

			if (myObject) {
				// If the object exists, update its attributes with the values in userInfo

				myObject.set("companyInsuranceInfo", dataToUpdate);
			} else {
				// If the object doesn't exist, create a new one
				const CommonDetails = Parse.Object.extend("CommonDetails");
				myObject = new CommonDetails();
				myObject.set("companyInsuranceInfo", dataToUpdate);
			}

			const createdOrUpdatedData = await myObject.save();

			return createdOrUpdatedData?.toJSON();
		} catch (error) {
			console.log(error);
			if (error?.message === "Network Error") {
				toast.error("Oops, Service provider has been disconnected!");
				throw Error(error?.message);
			} else {
				toast.error("Failed to update details");
				throw Error(error?.message);
			}
		}
	} catch (error) {
		console.log(error);
		toast.error("Failed to update details");
	}
};

export const getCompanyInsuranceInfo = async () => {
	try {
		const query = new Parse.Query("CommonDetails");
		query.exists("companyInsuranceInfo");
		const response = await query.first();

		return response?.toJSON();
	} catch (error) {
		console.log(error);
		throw Error(error);
	}
};
